<template>
  <div class='single-chart-circle'>
    <svg viewBox="0 0 32 34" class="circular-chart">
      <path :stroke-width='1.3' :stroke='config.backgroundStroke' class="circle-bg"
        d="M16 2
          a 15 15 0 0 1 0 30
          a 15 15 0 0 1 0 -30"
      />
      <path :stroke-width='configOrDefault("width", "1.3")' :stroke='config.stroke' :class="{circle: true, ready: ready}"
        :stroke-dasharray="arcStroke()"
        d="M16 2
          a 15 15 0 0 1 0 30
          a 15 15 0 0 1 0 -30"
      />
      <text v-if='configOrDefault("showPercent", true)' x="16" y="20" :fill='config.titleColor' class="percentage" v-html='title'></text>
      <text x="16" y="22" :fill='configOrDefault("textColor", "#ababab")' class='helptext'>{{text}}</text>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    progress: {
      type: Number,
      default () { return 0 }
    },
    config: {
      type: Object,
      default () { return {} }
    },
    title: {
      type: String,
      default () { return '' }
    },
    text: {
      type: String,
      default () { return '' }
    }
  },
  data () {
    return {
      ready: false
    }
  },
  methods: {
    arcStroke () {
      return this.percentVal() + ', 100'
    },
    percentVal () {
      return (this.progress * 100)
    },
    configOrDefault (key, defaultValue) {
      if (typeof this.config[key] !== 'undefined') {
        return this.config[key]
      } else {
        return defaultValue
      }
    }
  },
  watch: {
    progress (oldVal, newVal) {
      this.ready = true
    }
  }
}
</script>
<style lang='scss'>
  .report.light {
    .single-chart-circle {
      .circle-bg {
        stroke: #efefef;
      }
    }
  }

  .report.dark {
    .single-chart-circle {
      .circle-bg {
        stroke: #444;
      }
    }
  }
</style>
<style lang='scss' scoped>
.single-chart-circle {
  width: 100%;
  justify-content: center ;
}

.circular-chart {
  width: 100%;
  display: block;
  margin: 10px auto;
}

.circle-bg {
  fill: none;
}

.circle {
  fill: none;
  stroke-linecap: round;
}

.ready {
  animation: progress 1s ease-out forwards;
}

.splash .column:last-child {padding-top:2%!important;display:none;}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.percentage {
  font-size: 0.5em;
  text-anchor: middle;
}
.helptext {
  font-size: 0.22em;
  text-anchor: middle;
}
</style>
